/// <amd-module name="SuiteCommerce.GridOrder.PriceSchedule.View"/>
define("SuiteCommerce.GridOrder.PriceSchedule.View", ["require", "exports", "underscore", "jQuery", "grid_order_cell_price_schedule.tpl", "SuiteCommerce.GridOrder.Configuration"], function (require, exports, _, jQuery, priceScheduleTemplate, GridOrder_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PriceScheduleViewPrototype = /** @class */ (function () {
        function PriceScheduleViewPrototype() {
        }
        Object.defineProperty(PriceScheduleViewPrototype.prototype, "template", {
            get: function () {
                return priceScheduleTemplate;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PriceScheduleViewPrototype.prototype, "events", {
            get: function () {
                return {
                    'click .grid-order-cell-price-schedule-expander-button': 'showPriceSchedules'
                };
            },
            enumerable: true,
            configurable: true
        });
        PriceScheduleViewPrototype.prototype.showPriceSchedules = function (event) {
            var parentRowCID = this.model.parentRowCID;
            var $priceSchedule = jQuery(".grid-order-price-schedule-" + parentRowCID);
            var $expanderButtonChevronIcon = jQuery(event.currentTarget).find('span');
            // Chevron icon statuses. They are required in order to animate that icon.
            if ($expanderButtonChevronIcon.hasClass('collapsed')) {
                $expanderButtonChevronIcon.removeClass('collapsed');
                $expanderButtonChevronIcon.addClass('open');
            }
            else {
                $expanderButtonChevronIcon.removeClass('open');
                $expanderButtonChevronIcon.addClass('collapsed');
            }
            _.each($priceSchedule, function (priceScheduleElementContainer) {
                if (jQuery(priceScheduleElementContainer).hasClass('in')) {
                    // @ts-ignore
                    jQuery(priceScheduleElementContainer).collapse('hide');
                    return;
                }
                // @ts-ignore
                jQuery(priceScheduleElementContainer).collapse('show');
            });
        };
        PriceScheduleViewPrototype.prototype.getContext = function () {
            var priceSchedule = this.model.priceSchedule;
            var matrixChildInternalId = this.model.matrixChildInternalId;
            var optionNotAvailable = this.model.optionNotAvailable;
            var showQuantityPricingButton = !this.model.priceSchedule
                && !matrixChildInternalId && !optionNotAvailable;
            return {
                showQuantityPricingButton: showQuantityPricingButton,
                priceSchedule: priceSchedule,
                matrixChildInternalId: matrixChildInternalId,
                quantityPricingLabel: GridOrder_Configuration_1.GridOrderConfiguration.quantityPricingLabel,
                parentRowCID: this.model.parentRowCID,
            };
        };
        return PriceScheduleViewPrototype;
    }());
    exports.PriceScheduleViewPrototype = PriceScheduleViewPrototype;
});
